import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/pages/login/login'
import Dashboard from '@/components/pages/dashboard/dashboard'
import OrderNew from '@/components/pages/order/order-new'
import Products from '@/components/pages/products/products'
import Inspiration from '@/components/pages/inspiration/inspiration'
import Basket from '@/components/pages/basket/basket'
import Navpage from '@/components/pages/navpage/navpage'
import Terms from '@/components/pages/terms/terms'
import NotFound from '@/components/pages/not-found/not-found'
import Contact from '@/components/pages/contact/contact.vue'

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/',
            name: 'Dashboard',
            component: Dashboard
        },
        {
            path: '/order/:productId',
            name: 'Order',
            component: OrderNew,
            props: true
        },
        {
            path: '/order/:productId/:orderId',
            name: 'EditOrder',
            component: OrderNew,
            props: true
        },
        {
            path: '/products',
            name: 'Products',
            component: Products
        },
        {
            path: '/inspiration',
            name: 'Inspiration Board',
            component: Inspiration,
            props: { zoom: true }
        },
        {
            path: '/basket',
            name: 'Basket',
            component: Basket
        },
        {
            path: '/terms',
            name: 'terms',
            component: Terms,
            props: { termType: 'terms' }
        },
        {
            path: '/cookie-policy',
            name: 'cookie-policy',
            component: Terms,
            props: { termType: 'cookie-policy' }
        },
        {
            path: '/privacy-policy',
            name: 'privacy-policy',
            component: Terms,
            props: { termType: 'privacy-policy' }
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact,
        },
        {
            // NB: This needs to be the last route!
            path: "*",
            component: NotFound
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js